// src/utils/api.js
import axios from "axios";
import { normalizeOpsImageResponse } from "./ops-image-url";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "";

export const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  headers: {
    "X-Requested-With": "XMLHttpRequest"
  }
});

api.interceptors.response.use(
  (response) => normalizeOpsImageResponse(response)
);

export const getJson = async (url, params = {}) => {
  const { data } = await api.get(url, { params });
  return data;
};

export const postJson = async (url, payload = {}) => {
  const { data } = await api.post(url, payload);
  return data;
};

export const putJson = async (url, payload = {}) => {
  const { data } = await api.put(url, payload);
  return data;
};

export const uploadFileToPresignedUrl = async (presignedUrl, file) => {
  await axios.put(presignedUrl, file, {
    headers: { "Content-Type": file.type || "application/octet-stream" }
  });
};

const ApiUrlUtils = {
  api,
  getJson,
  postJson,
  putJson,
  uploadFileToPresignedUrl
};

export default ApiUrlUtils;